// @ts-strict-ignore
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserContext } from '~/dashboard/context';
import apiCalls from '~/helpers/apiCalls';
import { typhonRoutes } from '~/helpers/routes';
import type { CustomQueryOpts } from '../@types/utils';
import type { JourneyFederatedMetadata } from './useGetJourneyFederationStatusQuery';

// ============================================================
//     TYPES
// ============================================================
type ApiResponse = {
  status_code: number;
  error: unknown | null;
  '_embedded': JourneyFederatedMetadata[];
};

// ============================================================
//     QUERY
// ============================================================
const queryKey = [typhonRoutes.embeddedFinance.getAllJourneyFederationStatus()] as const;

/**
 * Get the AFEF federated status of all Journeys in the current customer
 */
export const useGetAllJourneysFederationMetadata = <
  TData extends JourneyFederatedMetadata[],
  TErr,
  TSel = TData,
>(
    options: CustomQueryOpts<TData, TErr, TSel> = {},
  ) => {
  const { typhonDomain } = useContext(UserContext);

  return useQuery(
    {
      queryKey,
      queryFn: async () => {
        const response = await apiCalls.embeddedFinance.getAllJourneyFederationStatus({
          typhonDomain,
        }) as ApiResponse;

        if (response.status_code !== 200) {
          Promise.reject(response);
        }

        // eslint-disable-next-line no-underscore-dangle
        return response._embedded;
      },
      ...options,
    });
};

useGetAllJourneysFederationMetadata.queryKey = queryKey;
